// extracted by mini-css-extract-plugin
export default {"disable-nav":"style_disable-nav__lf6wm","sidebar":"style_sidebar__DC59Z"};